@if (snackbarOpen()) {
  <div>
    <ng-container *transloco="let t; read: 'lex-xi-snackbar-component'">
      <xi-snack-bar
        [autoDismiss]="snackbarData().autoDismiss"
        [mode]="snackbarData().mode"
        [dismissTime]="snackbarData().duration"
        [text]="snackbarText()"
        [id]="snackbarData().id"
        [actionText]="t('dismiss')"
        (onClick)="onSnackbarClicked($event)"
      ></xi-snack-bar>
    </ng-container>
  </div>
}
